import { useQuery } from "data/hooks/useQuery";
import InvoiceSimulationDTO from "features/contracts/dtos/InvoiceSimulationDTO";
import React from "react";
import { useParams } from "react-router";
import { InvoiceSimulations, Billings_BillingDetails } from "data/endpoints";
import InvoiceSimulationDetailRecapitulation from "../components/detail/InvoiceSimulationDetailRecapitulation";
import BillingDetailDTO from "features/billings/dtos/BillingDetailDTO";
import BillingAreaList from "features/billings/components/BillingAreaList";

interface Props {
  id?: string;
}

const InvoiceSimulationDetailSection = (props: Props) => {
  const { id: invoiceSimulationId } = useParams<Props>();

  const { data: invoiceSimulation } = useQuery<InvoiceSimulationDTO>(
    {
      url: InvoiceSimulations,
      params: new URLSearchParams({
        InvoiceSimulationId: invoiceSimulationId?.toString() ?? "",
      }),
    },
    {},
    [invoiceSimulationId]
  );

  const { data: billingDetails } = useQuery<BillingDetailDTO[]>(
    {
      url: Billings_BillingDetails,
      routeParams: new URLSearchParams({
        billingId: invoiceSimulationId?.toString() ?? "",
      }),
    },
    [],
    [invoiceSimulationId]
  );

  // RENDER
  return (
    <>
      <div className="row no-gutters mx-n2">
        <div className="col-xl-12 px-2">
          {Object.keys(invoiceSimulation).length > 0 && (
            <InvoiceSimulationDetailRecapitulation
              invoiceSimulation={invoiceSimulation}
            />
          )}
        </div>
      </div>

      <BillingAreaList
        billingDetails={billingDetails}
        periodFrom={invoiceSimulation.periodFrom!}
        periodTo={invoiceSimulation.periodTo!}
      />      
    </>
  );
};

export default InvoiceSimulationDetailSection;
